


const mainNavigation = document.querySelector('.main-navigation');
const body = document.querySelector('body');



function toggleNavOnEsc (evt) {
  if (evt.key === 'Escape') {
    toggleMainNav(evt);
  }
}



export default function toggleMainNav (evt) {
  if (evt.target.closest('.main-navigation') !== null) return;
  evt.preventDefault();

  body.removeEventListener('click', toggleMainNav);
  window.removeEventListener('keyup', toggleNavOnEsc);

  const showNav = mainNavigation.getAttribute('aria-hidden') === 'true';
  mainNavigation.setAttribute('aria-hidden', !showNav);
  body.classList.toggle('main-nav-open');

  if ( showNav ) {
    window.setTimeout(() => {
      body.addEventListener('click', toggleMainNav);
    }, 1);

    window.addEventListener('keyup', toggleNavOnEsc);
  }
}
